export enum WidgetPermission {
  Documents = 'widget:documents',
  Questionnaires = 'widget:questionnaires',
  Notes = 'widget:notes',
  Diary = 'widget:diary',
  Messenger = 'widget:messenger',
  Patients = 'widget:patients',
  Representations = 'widget:representations',
  Appointments = 'widget:appointments',
  JumpingPoint = 'widget:jumpingpoint',
  Monitoring = 'widget:monitoring',
  PermissionAndPolicy = 'widget:permissionandpolicy',
  InactiveAccounts = 'widget:inactiveaccounts',
  Reports = 'widget:reports',
  Materialpool = 'widget:materialpool',
}
